<template>
    <div class="print-page full-height">
        <table-con>
            <div slot="search">
                <el-form ref="form" :model="form" size="small" label-width="5rem" label-position="right">
                    <el-row :gutter="24">
                        <el-col :span="6">
                            <el-form-item label="员工:">
                                <el-input v-model="form.createUserName" placeholder="请输入员工"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="时间:">
                                <el-date-picker style="width: 300px;" v-model="createTime" type="daterange"
                                    value-format="yyyy-MM-dd" size="small" range-separator="至" start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <div style="display: flex;justify-content: end;">
                            <el-button class="search-btn btn-gray" @click="handleReset">重置 </el-button>
                            <el-button class="search-btn btn-blue" @click="handleQuery">搜索</el-button>
                        </div>

                    </el-row>
                </el-form>
            </div>
            <!-- 表格 -->
            <div slot="table" class="full-height display-col">
                <el-table :height="tableResize.tableHeight" :data="tableList" style="width: 100%margin-bottom:15px"
                    :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" border
                    v-loading="loading">
                    <el-table-column label="操作" align="center">
                        <template #default="{ row }">
                            <el-button class="search-btn btn-blue" @click="getPrint(row)">打印</el-button>
                            <el-button class="search-btn btn-red" @click="getDelete(row)">删除</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createUserName" label="员工" align="center">
                    </el-table-column>
                    <el-table-column prop="createTime" label="时间" align="center">
                        <template #default="{ row }">{{ row.createTime }}</template>
                    </el-table-column>
                    <el-table-column prop="waybillNumber" label="运单号" align="center">
                    </el-table-column>
                    <el-table-column prop="customerRealName" label="用户ID" align="center">
                    </el-table-column>
                    <el-table-column prop="number" label="NO数量" align="center">
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="queryInfo.pageNum" :page-sizes="[5, 10, 20, 50, 100, 200]"
                    :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="total"></el-pagination>
            </div>

        </table-con>
        <!-- 打印弹窗 -->
        <el-dialog title="打印预览" :visible.sync="dialogFormVisible" v-if="dialogFormVisible" align="center">
            <div id="printContent" style="width: 100%;">
                <el-table style="width: 100%;" border :data="printList">
                    <el-table-column prop="no" label="NO" align="center" width="auto">
                      <template slot-scope="scope">
                        <div :class="{'table-column': true}">
                          {{ scope.row.no }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column  prop="customerUserName" label="客户姓名" align="center" width="auto">
                    </el-table-column>
                    <el-table-column prop="type" label="FBA/YFF/ZOZO/RSL/STOCKCREW" align="center" width="50">
                    </el-table-column>
                    <el-table-column prop="tradeName" label="商品名" align="center" width="200">
                    </el-table-column>
                    <el-table-column prop="specifications" label="规格" align="center" width="150">
                        <template #default="{ row }">
                          <div :class="{'table-column': true}">
                            <p>颜色：{{ row.specifications }}</p>
                            <p>尺寸：{{ row.goodsSize }}</p>
                          </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="fnSku" label="SKU" align="center" width="auto">
                    </el-table-column>
                    <el-table-column prop="number" label="数量" align="center" width="auto">
                    </el-table-column>
                    <el-table-column prop="type" label="检品项" align="center" width="auto">
                      <template slot-scope="scope">
                        <div :class="{'table-type': true}">
                          {{ scope.row.type }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" label="实际到货数量" align="center" width="50">
                    </el-table-column>
                    <el-table-column prop="name" label="检品数量" align="center" width="50">
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" v-print="printContent">打印</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { TableResize } from '@/assets/js/utils'
export default {
    name: 'printList',
    data() {
        return {
            tableResize: new TableResize(260),
            dialogFormVisible: false,
            form: {},
            createTime: undefined,
            queryInfo: {
                pageNum: 1,
                pageSize: 10,
            },
            total: 10,
            loading: false,
            tableList: [],
            printList: [],
            id: undefined,//用于删除
            printContent: {
                id: "printContent",
                preview: false,
                popTitle: undefined,
                openCallback(vue) {
                    // console.log('执行了打印', vue)
                    vue.getDelete(vue.id)
                    vue.getList()
                    vue.dialogFormVisible = false
                },
            }
        }
    },
    watch: {
        createTime() {
            if (!this.createTime) {
                this.createTime = undefined
                this.form.createTimeStart = undefined
                this.form.createTimeEnd = undefined
            } else {
                // console.log(this.createTime);
                this.form.createTimeStart = this.createTime[0] + ' 00:00:00'
                this.form.createTimeEnd = this.createTime[1] + ' 23:59:59'
            }
        }
    },
    mounted() {
        this.tableResize.onRun()
        // console.log('onRun', this.tableResize)
    },
    destroyed() {
        this.tableResize.onStop()
    },
    created() {
        this.getList()
    },
    methods: {
        async getList() {
            let data = {
                ...this.form,
                ...this.queryInfo
            }
            const { data: res } = await this.$http.get("/orderPrint/getList", { params: data });
            this.tableList = res.data.list
            this.total = res.data.total
        },
        // 删除打印过的数据
        async getDelete(row) {
            let ids = row.id ? row.id : row
            const { data: res } = await this.$http.get("/orderPrint/printDelete", { params: { id: ids } })
            if (res.code === 200) {
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
                this.getList()
            }
        },
        // 打印
        async getPrint(row) {
            this.id = row.id
            // 客户名
            this.printContent.popTitle = row.createUserName
            this.dialogFormVisible = true
            let data = {
                orderId: row.orderId,
                customerUserName: row.customerRealName,
                id: row.id
            }
            const { data: res } = await this.$http.get("/orderPrint/print", { params: data });
            this.printList = res.data
        },
        // 搜索
        handleQuery() {
            this.getList()
        },
        // 重置
        handleReset() {
            this.form = {}
            this.createTime = undefined
            this.getList()
        },
        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getList();
        },
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage;
            this.getList();
        },
    }
}
</script>
<style lang="less" scoped>
@page {
    margin: 3rem;
    size: auto;
}

@media print {
    #printContent {
        // box-sizing: border-box;
        margin: auto;
        // padding: 15px;

        ::v-deep .el-table {
            height: auto;
            width: 100% !important;
            max-width: 100%;
            border: 1px solid gray;
            box-sizing: border-box;

            table {
                table-layout: auto !important;
                width: 100% !important;
                height: auto;
                //font-weight: bold;
            }

            .el-table__body,
            .el-table__header {
                width: 100% !important;
                border: 1px solid gray;
                //font-weight: bold;
            }

            .el-table__body {
                width: 100% !important;
                table-layout: auto !important;
                border: 1px solid gray;
                //font-weight: bold;
            }
        }
    }
    .table-column {
      font-weight: bold;
      font-size: 25px !important;
    }

}
</style>
